var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{directives:[{name:"show",rawName:"v-show",value:(_vm.loggedIn),expression:"loggedIn"}],staticStyle:{"height":"100%"}},[(_vm.selectedView != null)?_c('view-grid',{ref:"viewGrid",attrs:{"view":_vm.selectedView,"fromDate":_vm.fromDate,"toDate":_vm.toDate}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }